(() => {
  if (window.ckRegionSelectorLoaded) return;
  window.ckRegionSelectorLoaded = true;
  let opener;
  const getDialog = () => document.getElementById('ck-region-dialog');
  const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  function filterCountries(dialog) {
    const query = normalize(dialog.querySelector('[type="search"]').value.trim());
    let visible = 0;
    dialog.querySelectorAll('[data-country-search]').forEach((row) => {
      row.hidden = !normalize(row.dataset.countrySearch).includes(query);
      if (!row.hidden) visible++;
    });
    dialog.querySelector('.ck-region-empty').hidden = visible > 0;
  }
  function init() {
    const dialog = getDialog();
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    const preferred = [dialog.querySelector('[name="country_code"]:checked')?.value, 'US', 'DE', 'JP', 'GB', 'CA', 'AU'];
    const grid = dialog.querySelector('.ck-region-grid');
    const rank = (row) => {
      const index = preferred.indexOf(row.querySelector('input').value);
      return index < 0 ? preferred.length : index;
    };
    [...grid.children].sort((a, b) => rank(a) - rank(b)).forEach((row) => grid.appendChild(row));
    dialog.querySelectorAll('[data-country-flag]').forEach((flag) => {
      flag.textContent = [...flag.dataset.countryFlag].map((letter) => String.fromCodePoint(letter.charCodeAt(0) + 127397)).join('');
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ck-region-is-open');
      document.querySelectorAll('[data-ck-region-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      opener?.focus();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.querySelector('[type="search"]').addEventListener('input', () => filterCountries(dialog));
    dialog.addEventListener('change', (event) => {
      if (!event.target.matches('[name="country_code"]')) return;
      const language = dialog.querySelector('[name="language_code"]');
      const preferred = { JP: 'ja', DE: 'de' }[event.target.value] || 'en';
      if ([...language.options].some((option) => option.value === preferred)) {
        language.value = preferred;
      }
    });
    dialog.querySelector('form').addEventListener('submit', (event) => {
      const form = event.currentTarget;
      const country = form.querySelector('[name="country_code"]:checked').value;
      const language = form.querySelector('[name="language_code"]').value;
      try { localStorage.setItem(dialog.dataset.choiceKey, JSON.stringify({ country, language })); } catch (_) { /* Storage may be disabled; the native form still works. */ }
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
      form.querySelector('[type="submit"]').disabled = true;
    });
  }
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-ck-region-open]');
    const closeButton = event.target.closest('[data-ck-region-close]');
    const dialog = getDialog();
    if (!dialog) return;
    if (openButton) {
      init();
      opener = openButton;
      dialog.querySelector('form').reset();
      dialog.querySelector('[type="submit"]').disabled = false;
      dialog.querySelector('[type="search"]').value = '';
      filterCountries(dialog);
      dialog.showModal();
      document.documentElement.classList.add('ck-region-is-open');
      openButton.setAttribute('aria-expanded', 'true');
      const countryList = dialog.querySelector('.ck-region-countries');
      countryList.scrollTop = 0;
      dialog.querySelector('[data-ck-region-close]').focus();
    }
    if (closeButton) dialog.close();
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', () => {
    const submit = getDialog()?.querySelector('[type="submit"]');
    if (submit) submit.disabled = false;
  });
  init();
})();
